import { createContext, useContext } from 'react';

export const AmpContext = createContext<boolean>(false);

export const useAmpContext = () => useContext(AmpContext);
